import { CreateSurvey, useGetBuySurveyContextQuery } from '@apps/materiality-tracker/api/materiality-assessment';
import { AssessmentType } from '@g17eco/types/survey';
import { skipToken } from '@reduxjs/toolkit/query';
import { useState } from 'react';

export interface AssessmentForm {
  month: number | undefined;
  year: number | undefined;
  answers: Partial<CreateSurvey['answers']>;
  assessmentType: AssessmentType | undefined;
  verificationRequired: boolean;
}

const defaultAssessmentForm: AssessmentForm = {
  answers: {},
  assessmentType: undefined,
  month: undefined,
  year: undefined,
  verificationRequired: false,
};

export const useCreateAssessmentForm = ({ initiativeId }: { initiativeId: string | undefined }) => {
  const { data: createSurveyContext, isLoading } = useGetBuySurveyContextQuery(
    initiativeId ? { initiativeId } : skipToken,
  );
  const [assessmentForm, setAssessmentForm] = useState<AssessmentForm>(defaultAssessmentForm);
  const utrs = createSurveyContext?.utrs ?? [];
  const utrCodes = utrs.map((utr) => utr.code);
  const isAllUtrsAnswered = utrCodes.every((code) => assessmentForm.answers[code]);

  const updateAssessmentForm = (field: keyof AssessmentForm, value: AssessmentForm[keyof AssessmentForm]) =>
    setAssessmentForm((prev) => ({
      ...prev,
      [field]: value,
    }));

  const handleOptionChange = (key: string, value?: string) => {
    updateAssessmentForm('answers', {
      ...assessmentForm.answers,
      [key]: value,
    });
  };

  return { utrs, assessmentForm, isAllUtrsAnswered, isLoading, updateAssessmentForm, handleOptionChange };
};
